import { ArrowRight, Check } from 'lucide-react';
import '../studio-products.css';

const products = [
  {
    id: 'spoolmark',
    name: 'Spoolmark',
    category: 'For 3D printing',
    status: 'Android available',
    purpose: 'Filament inventory',
    description:
      'Find the filament you own, check what is left, and keep every spool easy to find with printable QR labels.',
    highlights: [
      'Mixed-brand inventory',
      'Weight & print history',
      'Offline QR labels',
    ],
    availability: 'Android now · iPhone coming soon',
    preview: 'iPhone preview · Inventory & labels',
  },
  {
    id: 'eldgard',
    name: 'Eldgard',
    category: 'For developers',
    status: 'In development',
    purpose: 'Firestore workspace',
    description:
      'Query your collections, review typed edits, and reproduce cloud data locally. Keep a read-only view handy on your phone.',
    highlights: [
      'Queries & typed edits',
      'Local emulator copies',
      'Read-only mobile companion',
    ],
    availability: 'Planned for desktop, iOS & Android',
    preview: 'Development preview · Desktop & mobile',
  },
] as const;

export function StudioProducts() {
  return (
    <div className="studio-products-grid">
      {products.map((product) => (
        <article
          className={`studio-product studio-product-${product.id}`}
          key={product.id}
          aria-labelledby={`studio-${product.id}-title`}
        >
          <div className="studio-product-copy">
            <div className="studio-product-meta">
              <p>{product.category}</p>
              <span className="studio-product-status">
                <span aria-hidden="true" />
                {product.status}
              </span>
            </div>
            <div className="studio-product-identity">
              <img
                src={`/images/${product.id}/app-icon.png`}
                width="52"
                height="52"
                alt=""
              />
              <div>
                <h2 id={`studio-${product.id}-title`}>{product.name}</h2>
                <p>{product.purpose}</p>
              </div>
            </div>
            <p className="studio-product-description">{product.description}</p>
            <ul
              className="studio-product-highlights"
              aria-label={`${product.name} highlights`}
            >
              {product.highlights.map((highlight) => (
                <li key={highlight}>
                  <Check size={15} aria-hidden="true" />
                  {highlight}
                </li>
              ))}
            </ul>
          </div>

          <figure className="studio-product-preview">
            <figcaption>{product.preview}</figcaption>
            {product.id === 'spoolmark' ? (
              <div className="studio-product-devices studio-product-spoolmark-devices">
                <div className="studio-product-phone">
                  <img
                    src="/images/spoolmark/inventory-light.webp"
                    alt="Spoolmark inventory with filament colors, storage locations, and remaining weights"
                    width="1206"
                    height="2622"
                    loading="lazy"
                    decoding="async"
                  />
                </div>
                <div className="studio-product-phone">
                  <img
                    src="/images/spoolmark/qr-label-dark.webp"
                    alt="A Spoolmark QR label linked to an inventory spool"
                    width="1206"
                    height="2622"
                    loading="lazy"
                    decoding="async"
                  />
                </div>
              </div>
            ) : (
              <div className="studio-product-devices studio-product-eldgard-devices">
                <div className="studio-product-desktop">
                  <img
                    src="/images/eldgard/bookings-table.webp"
                    alt="Eldgard desktop table showing typed fields in a sample Firestore collection"
                    width="2400"
                    height="1500"
                    loading="lazy"
                    decoding="async"
                  />
                </div>
                <div className="studio-product-phone">
                  <img
                    src="/images/eldgard/mobile-document-fields.png"
                    alt="Eldgard mobile companion showing a read-only document with typed fields"
                    width="780"
                    height="1688"
                    loading="lazy"
                    decoding="async"
                  />
                </div>
              </div>
            )}
          </figure>

          <div className="studio-product-footer">
            <p>{product.availability}</p>
            <a href={`/${product.id}`}>
              Explore {product.name}
              <ArrowRight size={18} aria-hidden="true" />
            </a>
          </div>
        </article>
      ))}
    </div>
  );
}
